import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { addMonths, format, parseISO } from 'date-fns';
import Header from './Header';
import Footer from './Footer';

function AccountDeletion() {
  
  
  return (

    <div className="container mx-auto">
      <Header></Header>
      <div class="p-10 text-sm/7">
  <div class="space-y-6 p-4">
    <p class="font-bold">Account and Data Deletion — MemberMeld</p>
    <p><span class="font-bold">Last updated:</span> April 27th, 2025</p>

    <div>
      <p>1. You can delete your account and all associated data directly within the app:</p>
      <p>Go to Setting - Profile - Edit Profile - Delete Option on right corner</p>
       <p>Confirm the deletion to permanently remove your profile and all related data</p>
    </div>
    <p>If you need assistance or want to request deletion of specific data, please contact us by email <a href="mailto:support@membermeld.com" className="text-[#00A6FB] hover:underline">
      support@membermeld.com
    </a></p>
    <p>We strive to respond to all deletion requests within 30 days.</p>
  </div>
</div>

      <Footer></Footer>
      </div>
  );
  
}

export default AccountDeletion;
